import React from 'react'
import PropTypes from 'prop-types'
import Edit from '@mui/icons-material/Edit'

const EditIcon = ({ height, width, ...more }) => {
	
	return (
		<Edit
			height={height}
			width={width}
			{...more}
		/>
	)
}

EditIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default EditIcon
